(() => {
    let autoComplete = require('@tarekraafat/autocomplete.js');
    let createDOMPurify = require('dompurify');
    let placeholder = 'Suchen';
    let userLang = navigator.language || navigator.userLanguage;
    let initial = document.querySelector('#initial');
    let searchWordSpan = document.querySelector('#search-word');
    let searchCountSpan = document.querySelector('#search-count');
    let allowedTags = [
        'filter-tax-sorting',
        'filter-tax-region',
        'filter-tax-sport',
        'filter-tax-theme',
        'filter-tax-industry',
        'filter-tax-origin',
    ];
    let autocompletes = [];

    // URL parameter names mapped to filter dropdown IDs
    const paramToDropdown = {
        'sort': 'filter-tax-sorting',
        'region': 'filter-tax-region',
        'sport': 'filter-tax-sport',
        'theme': 'filter-tax-theme',
        'industry': 'filter-tax-industry',
        'origin': 'filter-tax-origin',
    };
    const dropdownToParam = Object.fromEntries(
        Object.entries(paramToDropdown).map(([k, v]) => [v, k])
    );

    /**
     * Read current filter state from URL query parameters
     */
    function getStateFromUrl() {
        const params = new URLSearchParams(window.location.search);
        return {
            searchWord: params.get('search') || '',
            'filter-tax-sorting': params.get('sort') || '',
            'filter-tax-region': params.get('region') || '',
            'filter-tax-sport': params.get('sport') || '',
            'filter-tax-theme': params.get('theme') || '',
            'filter-tax-industry': params.get('industry') || '',
            'filter-tax-origin': params.get('origin') || '',
            page: parseInt(params.get('page') || '0'),
            offset: parseInt(params.get('offset') || '0'),
        };
    }

    /**
     * Write current filter state to URL without page reload
     */
    function pushStateToUrl(state) {
        const params = new URLSearchParams();
        if (state.searchWord) params.set('search', state.searchWord);
        for (const [param, dropdown] of Object.entries(paramToDropdown)) {
            if (param === 'sort') continue; // handle sorting separately
            if (state[dropdown]) params.set(param, state[dropdown]);
        }
        if (state['filter-tax-sorting'] && state['filter-tax-sorting'] !== getDefaultSorting(state.searchWord)) {
            params.set('sort', state['filter-tax-sorting']);
        }
        if (state.page > 0) params.set('page', state.page);
        if (state.offset > 0) params.set('offset', state.offset);

        const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        history.pushState(null, '', newUrl);
    }

    /**
     * Determine default sorting based on whether a search word is present
     */
    function getDefaultSorting(searchWord) {
        return searchWord ? 'relevance' : 'survey_period_end';
    }

    /**
     * Build the filterTags JSON string that the PHP backend expects.
     * Format: JSON array of JSON strings, each string is an array of {dropdown, identifier, title} objects.
     */
    function buildFilterTagsFromState(state) {
        let filterTags = [];

        allowedTags.forEach(function (dropdownId) {
            let value = state[dropdownId];
            if (!value) return;

            let ids = value.split(',');
            let tags = ids.map(function (id) {
                return {
                    dropdown: dropdownId,
                    identifier: id,
                    title: findTitleForIdentifier(dropdownId, id),
                };
            });

            filterTags.push(JSON.stringify(tags));
        });

        return JSON.stringify(filterTags);
    }

    /**
     * Try to find the display title for a filter identifier from the DOM.
     * Falls back to the identifier itself if not found.
     */
    function findTitleForIdentifier(dropdownId, identifier) {
        let container = document.querySelector('#' + dropdownId);
        if (container) {
            let item = container.querySelector('[data-identifier="' + identifier + '"]');
            if (item) {
                return item.textContent.trim();
            }
        }
        return identifier;
    }

    /**
     * Update URL state when a filter is toggled
     */
    function updateFilterInUrl(dropdownId, identifier, remove) {
        let state = getStateFromUrl();
        let current = state[dropdownId] ? state[dropdownId].split(',').filter(Boolean) : [];

        if (remove) {
            current = current.filter(function (id) { return id !== identifier; });
        } else if (dropdownId === 'filter-tax-sorting') {
            current = [identifier];
        } else if (current.indexOf(identifier) !== -1) {
            current = current.filter(function (id) { return id !== identifier; });
        } else {
            current.push(identifier);
        }

        state[dropdownId] = current.join(',');
        state.searchWord = document.querySelector('#searchFormField').value;
        // Reset pagination on filter change
        state.page = 0;
        state.offset = 0;
        pushStateToUrl(state);
    }

    const initStateReady = () => {
        // Clean up any leftover cookies from the old implementation
        allowedTags.forEach(function (filterId) {
            document.cookie = filterId + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        });

        // Restore search field from URL state
        let state = getStateFromUrl();
        let searchField = document.querySelector('#searchFormField');
        if (searchField && state.searchWord) {
            searchField.value = state.searchWord;
        }

        if (initial) {
            startSearch('', true).then();
            initial.remove();
        }
        if (!userLang.includes('de-')) {
            placeholder = 'Search';
        }

        // Handle browser back/forward navigation
        window.addEventListener('popstate', function () {
            let popState = getStateFromUrl();
            let field = document.querySelector('#searchFormField');
            if (field) {
                field.value = popState.searchWord;
            }
            startSearch('', true).then();
        });

        document.body.addEventListener('click', function (event) {
            if (event.target.classList.contains('dropdownButton')) {
                let autocompleteFields = document.querySelectorAll('.autocomplete-search-field');

                if (autocompleteFields) {
                    autocompleteFields.forEach((autocompleteField) => {
                        let id = autocompleteField.getAttribute('id');
                        let searchValues = createAutocompleteValues(id);

                        if (searchValues) {
                            // reset autocomplete on click
                            autocompleteField.value = '';
                            showDropdownValues(autocompleteField);
                            // init autocomplete
                            autocompletes[id] = initAutocomplete(id, searchValues, placeholder);
                        }
                    });
                }
            }
            if (event.target.classList.contains('submit-dropdown-items')) {
                startSearch(event.target, true).then();
            }
            if (event.target.classList.contains('dropdown-item')) {
                if (event.target.getAttribute('data-disabled') !== '0') {
                    handleFilterTags(event.target);
                    if (event.target.closest('.dropdown-container').getAttribute('id') === 'filter-tax-sorting') {
                        startSearch(event.target, true).then();
                    }
                }
            }
            if (event.target.classList.contains('Pagination-item-a')) {
                let paginationOffset = parseInt(event.target.getAttribute('data-from') || '0');
                let paginationPage = parseInt(event.target.getAttribute('data-page') || '0');

                // Update URL with pagination
                let paginationState = getStateFromUrl();
                paginationState.offset = paginationOffset;
                paginationState.page = paginationPage;
                pushStateToUrl(paginationState);

                startSearch(event.target).then((_) => {
                    // scroll back up
                    let searchResults = document.querySelector('#searchResults');
                    if (searchResults) {
                        searchResults.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest',
                        });
                    }
                });
                event.preventDefault();
            }
            if (event.target.classList.contains('removeChoosenFilterTag')) {
                let dropdownId = event.target.getAttribute('data-dropdown');
                let identifier = event.target.getAttribute('data-identifier');
                updateFilterInUrl(dropdownId, identifier, true);
                startSearch(event.target, true).then();
                event.preventDefault();
            }
        });
    };

    const createAutocompleteValues = (id) => {
        let searchValues = [];

        document
            .querySelector('#filter-tax-' + id)
            .querySelectorAll('.dropdown-item')
            .forEach((item) => {
                let values = {
                    identifier: item.getAttribute('data-identifier'),
                    disabled: item.getAttribute('data-disabled'),
                    label: item.innerHTML,
                };
                searchValues.push(values);
            });

        return searchValues;
    };

    /**
     * return created autocomplete object
     * @param name
     * @param searchValues
     * @param placeHolder
     * @returns {*}
     */
    const initAutocomplete = (name, searchValues, placeHolder) => {
        return new autoComplete({
            name: name,
            id: name,
            placeHolder: placeHolder,
            selector: '#' + name,
            threshold: 2,
            wrapper: false,
            searchEngine: 'strict',
            diacritics: true,
            data: {
                src: searchValues,
                keys: ['label'],
            },
            query: (input) => {
                return createDOMPurify.sanitize(input, {
                    USE_PROFILES: { html: true },
                });
            },
            resultsList: {
                tag: 'div',
                id: 'autocomplete-filter-tax-' + name,
                class: 'dropdown-menu show autocomplete-list',
                destination: '#' + name,
                position: 'afterend',
                maxResults: 5,
                noResults: true,
                element: (list, data) => {
                    list.setAttribute('data-parent', name + '-list');
                },
            },
            resultItem: {
                tag: 'a',
                class: 'dropdown-item dropdown-item-autocomplete',
                element: (item, data) => {
                    item.setAttribute('data-parent', name);
                    item.setAttribute('data-identifier', data.value.identifier);
                    item.setAttribute('data-disabled', data.value.disabled);

                    if (data.value.disabled === '0') {
                        item.classList.add('disabled');
                    }
                },
                highlight: false,
                selected: 'selectedVal',
            },
            events: {
                input: {
                    keyup: (event) => {
                        if (event.target.value.length >= 2) {
                            hideDropdownValues(event.target);
                        } else {
                            showDropdownValues(event.target);
                        }
                    },
                },
            },
        });
    };

    const startSearch = async (event, filter = false) => {
        let searchFormFilter = document.querySelector('#searchFormFilter');
        let action = '/api/filter/search';
        let formData = new FormData();
        if (searchFormFilter) {
            formData = new FormData(searchFormFilter);
        }

        formData = buildFormData(event, formData);

        let promises = [];

        // get search results
        const resultsPromise = sendRequest(
            action,
            formData,
            '#searchResults',
            document.querySelector('#loader-overlay')
        );

        promises.push(resultsPromise);

        if (filter) {
            // build filters
            const filterPromise = sendRequest('/api/filter/generate', formData, '#filters');
            promises.push(filterPromise);
        }

        await Promise.all(promises);
    };

    function handleFilterTags(event, removeCookie = false) {
        let dropdownId = '';
        if (event) {
            // create filter tag
            if (!removeCookie) {
                dropdownId = event.closest('.dropdown-container').getAttribute('id');
            } else {
                dropdownId = event.getAttribute('data-dropdown');
            }

            // we need also to toogle autocomplete values
            if (event.classList.contains('dropdown-item-autocomplete')) {
                let closestAutocompleteFields = autocompletes[event.getAttribute('data-parent')];
                closestAutocompleteFields.close();
                selectDropdownValues(event.parentNode.parentNode, event.getAttribute('data-identifier'));
                showDropdownValues(event.parentNode.parentNode);
            } else {
                // Update URL state instead of cookies
                updateFilterInUrl(dropdownId, event.getAttribute('data-identifier'), removeCookie);
            }
            if (!removeCookie && !event.classList.contains('dropdown-item-autocomplete')) {
                toogleIcon(event);
                event.classList.toggle('selected');
            }
        }
    }

    function toogleIcon(event) {
        let close =
            '<svg\n' +
            '            id="close"\n' +
            '            className="hide"\n' +
            '            xmlns="http://www.w3.org/2000/svg"\n' +
            '            viewBox="0 0 50 50"\n' +
            '        >\n' +
            '            <path\n' +
            '                id="path-1"\n' +
            '                d="M 49.023 0.977 C 47.723 -0.325 45.612 -0.325 44.309 0.977 L 24.997 20.288 L 5.685 0.977 C 3.867 -0.833 0.771 0.006 0.112 2.486 C -0.191 3.632 0.137 4.852 0.971 5.691 L 20.284 25.003 L 0.971 44.314 C -0.837 46.134 0 49.229 2.48 49.887 C 3.626 50.19 4.846 49.863 5.685 49.028 L 24.997 29.715 L 44.309 49.028 C 46.13 50.838 49.226 49.999 49.882 47.519 C 50.185 46.373 49.858 45.153 49.023 44.314 L 29.711 25.003 L 49.023 5.691 C 50.325 4.388 50.325 2.279 49.023 0.977 Z"\n' +
            '                data-bx-origin="1.315 0.781"\n' +
            '            ></path>\n' +
            '        </svg>';
        let open =
            '<svg\n' +
            '        id="plus"\n' +
            '        class="show"\n' +
            '        xmlns="http://www.w3.org/2000/svg"\n' +
            '        width="24.069"\n' +
            '        height="24.069"\n' +
            '        viewBox="0 0 24.069 24.069"\n' +
            '    >\n' +
            '        <path\n' +
            '            id="_UI"\n' +
            '            data-name="+ UI"\n' +
            '            d="M33.619,32.476,26.253,25.11l7.367-7.367L32.476,16.6,25.11,23.967,17.743,16.6,16.6,17.743l7.367,7.367L16.6,32.476l1.143,1.143,7.367-7.367,7.367,7.367Z"\n' +
            '            transform="translate(-23.476 12.035) rotate(-45)"\n' +
            '        />\n' +
            '    </svg>';

        if (event.classList.contains('selected')) {
            event.querySelector('.dropdown-item-icon').innerHTML = open;
        } else {
            event.querySelector('.dropdown-item-icon').innerHTML = close;
        }
    }

    /**
     * hide dropdwon values if autocomplete is working
     * @param event
     */
    function hideDropdownValues(event) {
        event
            .closest('.dropdown-menu')
            .querySelectorAll('.initial-loaded')
            .forEach((item) => {
                item.classList.add('hide');
            });
    }

    /**
     * show dropdwon values if autocomplete is working
     * @param event
     */
    function showDropdownValues(event) {
        event
            .closest('.dropdown-menu')
            .querySelectorAll('.initial-loaded')
            .forEach((item) => {
                item.classList.remove('hide');
            });
    }

    function selectDropdownValues(event, identifier) {
        event
            .closest('.dropdown-menu')
            .querySelectorAll('.initial-loaded')
            .forEach((item) => {
                if (item.getAttribute('data-identifier') === identifier) {
                    item.click();
                }
            });
    }

    function buildFormData(event, formData) {
        let state = getStateFromUrl();
        let from = state.offset;
        let page = state.page;

        // Pagination click overrides
        if (event && event.getAttribute && event.getAttribute('data-from') !== null && event.getAttribute('data-from') !== undefined) {
            let dataFrom = event.getAttribute('data-from');
            let dataPage = event.getAttribute('data-page');
            if (dataFrom !== null) from = parseInt(dataFrom);
            if (dataPage !== null) page = parseInt(dataPage);
        }

        formData.append('searchWord', document.querySelector('#searchFormField').value);
        formData.append('offset', from);
        formData.append('page', page);

        // Build filterTags JSON from URL state (same format PHP expects)
        formData.append('filterTags', buildFilterTagsFromState(state));

        return formData;
    }

    /**
     * send request
     * @param action
     * @param formData
     * @param container
     * @param loader
     */
    function sendRequest(action, formData, container, loader) {
        // add loading animation
        if (loader) {
            loader.classList.add('show');
        }

        // fetch
        return fetch(action, {
            method: 'POST',
            body: formData,
        })
            .then(function (response) {
                if (response.ok) {
                    return response.text();
                }
                return Promise.reject(response);
            })
            .then(function (data) {
                if (data) {
                    document.querySelector(container).innerHTML = data;
                    if (loader) {
                        loader.classList.remove('show');
                    }
                }
                if (action === '/api/filter/search') {
                    if (document.querySelector('#hidden-search-word').value) {
                        searchWordSpan.innerText = '"' + document.querySelector('#hidden-search-word').value + '"';
                    }
                    searchCountSpan.innerText = '(' + document.querySelector('#hidden-search-count').value + ')';
                }
                if (action === '/api/filter/generate') {
                    if (document.querySelector('#hide-if-loaded')) {
                        document.querySelector('#hide-if-loaded').style.display = 'none';
                    }
                }
            })
            .catch(function (error) {
                if (loader) {
                    loader.classList.remove('show');
                }
                console.warn(error);
            });
    }

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') {
            return;
        }

        initStateReady();
    });
})();
